module.exports = __webpack_public_path__ + "static/assets/267dc9220099302335bf68bd4f20b80e.svg";